<template>
    <div class="ca-and-third">
        <p
            v-for="(item,index) in data.thirdparties"
            :key="item.thirdpartyid"
            class="ca"
            v-czc="['交易中心','点击列表', '第三方平台' , index+1 ,`tradeCenter-list-CAAndThird`]"
        >
            <el-tooltip
                :disabled="item.thirdpartyname.length < 13"
                class="item"
                effect="dark"
                :content="item.thirdpartyname"
                placement="top-start"
            >
                <el-link :href="item.weblink" target="_blank" :underline="false" class="ca-name">{{ item.thirdpartyname }}</el-link>
            </el-tooltip>
        </p>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState({
            data: (state) => {
                return state.dealcenter.data;
            },
        }),
    },
};
</script>

<style lang="scss" scoped>
.ca-and-third{
    padding-top: 20px;
}

.ca {
    font-size: 12px;
    color: #333;
    display: block;
    width: 240px;
    float: left;
    margin-right: 60px;

    .ca-name {
        display: block;
        float: left;
        width: 170px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-bottom: 18px;
        color: #333;
    }
    .ca-name:hover{
        color: #3d7eff;
    }

    .ca-url {
        font-size: 12px;
        color: #333;
        float: right;
    }
    .ca-url:hover{
        color: #3d7eff;
    }
}
.ca:nth-child(4n) {
    margin-right: 20px;
}
</style>